<div class="exit-form strategy-form-section display-flex-column padding-bottom">
    <form autocomplete="off" [formGroup]="exitForm">
        <div class="responsive-flex form-row form-row-1">
            <mat-form-field class="ut-pro-mat-form-field label-field pad-8-hr spacer" appearance="outline"
                color="accent" *ngIf="(strategyMode$ | async) !== StrategyFormBuildMode.REGULAR">
                <label class="ut-label">
                    Percentage/Absolute
                </label>

                <mat-select formControlName="isPercent" (selectionChange)="onValueTypeChange()">
                    <mat-option [value]="true">
                        Percentage Values
                    </mat-option>
                    <mat-option [value]="false">
                        Absolute Values
                    </mat-option>
                </mat-select>

                <mat-error *ngIf="exitForm.get('isPercent').hasError('required')">
                    Profit is required
                </mat-error>
            </mat-form-field>

            <mat-form-field class="ut-pro-mat-form-field label-field pad-8-hr spacer" appearance="outline"
                color="accent">
                <label class="ut-label">
                    Target Profit

                    <ng-container *ngIf="isPercentage">
                        (%)
                    </ng-container>
                </label>

                <div class="ng-spin-box-wrapper">
                    <input matInput ngSpinBox formControlName="takeProfit"
                        [max]="isPercentage? MAX_PERCENTAGE : MAX_ABSOLUTE_VALUE"
                        [min]="isPercentage ? MIN_PERCENTAGE: MIN_ABSOLUTE_VALUE" [decimal]="DEFAULT_PRECISION"
                        [step]="isPercentage ? MIN_PERCENTAGE : MIN_ABSOLUTE_VALUE">
                </div>

                <mat-error *ngIf="exitForm.get('takeProfit').hasError('required')">
                    Profit is required
                </mat-error>

                <mat-error *ngIf="exitForm.get('takeProfit').hasError('min')">
                    Profit should be greater than or equal to {{isPercentage ? MIN_PERCENTAGE : MIN_ABSOLUTE_VALUE}}
                </mat-error>

                <mat-error *ngIf="exitForm.get('takeProfit').hasError('max')">
                    Profit should be less than or equal to {{isPercentage ? MAX_PERCENTAGE : MAX_ABSOLUTE_VALUE}}
                </mat-error>
            </mat-form-field>
            <div class="or text-accent flex-centered-container padding"
                *ngIf="(strategyMode$ | async) === StrategyFormBuildMode.REGULAR">
                -OR-
            </div>

            <mat-form-field class="ut-pro-mat-form-field label-field pad-8-hr spacer" appearance="outline"
                color="accent">
                <label class="ut-label">
                    Stop Loss
                    <ng-container *ngIf="isPercentage">
                        (%)
                    </ng-container>
                </label>

                <div class="ng-spin-box-wrapper">
                    <input matInput ngSpinBox type="text" formControlName="stopLoss"
                        [max]="isPercentage ? MAX_PERCENTAGE_100 : MAX_ABSOLUTE_VALUE"
                        [min]="isPercentage ? MIN_PERCENTAGE : MIN_ABSOLUTE_VALUE" [decimal]="DEFAULT_PRECISION"
                        [step]="isPercentage ? MIN_PERCENTAGE : MIN_ABSOLUTE_VALUE">
                </div>

                <mat-error *ngIf="exitForm.get('stopLoss').hasError('required')">
                    Stop loss is required
                </mat-error>

                <mat-error *ngIf="exitForm.get('stopLoss').hasError('min')">
                    Stop Loss should be greater than or equal to {{isPercentage ? MIN_PERCENTAGE : MIN_ABSOLUTE_VALUE}}
                </mat-error>

                <mat-error *ngIf="exitForm.get('stopLoss').hasError('max')">
                    Stop Loss should be less than or equal to {{isPercentage ? MAX_PERCENTAGE_100 : MAX_ABSOLUTE_VALUE}}
                </mat-error>
            </mat-form-field>

            <div class="pad-8-hr spacer flex-centered-container-hr trailing-stoploss-tick" *ngIf="isWizardMode | async">
                <mat-checkbox color="accent" class="pad-8-right margin-bottom" formControlName="enableTrailingTicks"
                    (change)="changeStopLossValidity($event)"></mat-checkbox>

                <mat-form-field class="ut-pro-mat-form-field label-field spacer" appearance="outline" color="accent">
                    <label class="ut-label">
                        Trailing Stop Loss Ticks
                    </label>

                    <div class="ng-spin-box-wrapper">
                        <input matInput ngSpinBox type="text" formControlName="trailingTicks" [min]="1" [step]="1"
                            appNumberOnly>
                    </div>

                    <mat-error *ngIf="exitForm.get('trailingTicks').hasError('required')">
                        Trailing stop loss tick is required
                    </mat-error>
                    <mat-error *ngIf="exitForm.get('trailingTicks').hasError('min')">
                        Trailing stop loss tick should have minimum value 1
                    </mat-error>
                </mat-form-field>
            </div>

        </div>
    </form>

    <div class="responsive-flex pad-8-hr" *ngIf="(strategyMode$ | async) !== StrategyFormBuildMode.REGULAR">
        <p class="text-accent cursor-pointer decoration-underline margin-vr"
            (click)="useConditionalExit = !useConditionalExit">
            {{ useConditionalExit ? 'Remove': 'Add' }} Exit Condition (Optional)
        </p>
    </div>

    <ng-container *ngIf="useConditionalExit">
        <app-basic-indicator-form class="margin-top" *ngIf="(strategyMode$ | async) === StrategyFormBuildMode.PRO">
        </app-basic-indicator-form>
        <app-advance-indicator-form *ngIf="(strategyMode$ | async) ===  StrategyFormBuildMode.WIZARD">
        </app-advance-indicator-form>
    </ng-container>
</div>